import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSheet,{staticClass:"smc-sheet-transparent workshop-slider"},[_c('h1',[_vm._v("Our workshop partners")]),_c('div',{staticClass:"py-2 my-2"}),_c('carousel',{attrs:{"autoplay":"","loop":"","perPageCustom":[
            [1000, 5],
            [768, 3],
            [480, 2] ],"autoplayTimeout":10000,"paginationColor":"transparent","paginationActiveColor":"transparent","paginationPosition":"bottom"}},_vm._l((_vm.workshopLogos),function(item,i){return _c('slide',{key:i},[_c('div',{staticClass:"pill"},[_c('img',{attrs:{"src":item.src}})])])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }